var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"u-button",class:[
    _vm.type ? 'u-button_' + _vm.type : '',
    {
      'is-automatic': _vm.automatic,
      'is-round': _vm.round,
      'is-circle': _vm.circle,
      'is-disabled': _vm.disabled,
      'is-loading': _vm.loading,
    } ],attrs:{"type":"button","disabled":_vm.disabled || _vm.loading},on:{"click":_vm.handleClick}},[(_vm.loading)?_c('i',{staticClass:"u-icon-loading"}):_vm._e(),(_vm.icon && !_vm.loading)?_c('i',{staticClass:"u-button_icon",class:_vm.icon}):_vm._e(),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }